<template>
    <div>
        <div class="header">
            <div class="headers">
                <div class="left">
                    <img src="http://open.beijing.gov.cn/common/images/icon/opbj.png">
                    <div class="title_text" @click="$router.push('/Usercenter')">{{ProjectName}}</div>
                </div>
                <div class="right"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      RouteList: [],
      ProjectName: process.env.VUE_APP_Project_Name
    }
  },
  methods: {
    activeIndex () {},
    handleSelect () {}
  },
  created () {
    if (this.$route.path !== '/') {
      this.RouteList = this.$UserCenterdRouter.list()
    }
  },
  watch: {
    // 按需加载路由，监听路由变化逻辑处理
    $route (to, from) {
      if (this.$route.path !== '/') {
        this.RouteList = this.$UserCenterdRouter.list()
      }
    //   const _this = this // 这里注意一下记得缓存this
    //   _this.$router.push({
    //     path: _this.$route.path // 这个值我们是可以拿到的
    //   })
    }
  }
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped>
.header{
        background: #BD1A2D;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 50px;
    .headers{
        width: 1200px;
        height: 100%;
        display: flex;
        .left{
            flex: 1;
            display: flex;
            align-items: center;
            .title_text{
                font-size: 20px;
                margin-left: 20px;
                color: #fff;
                width: 200px;
                cursor: pointer;
            }
        }
        .main{
            flex: 3;
        }
        .right{
            // background: rgb(47, 0, 255);
            flex: 0.5;
        }
    }
}
</style>
